import WithTreeData from '@/components/WithTreeData'
import { PassiveTreeWithSearch } from '@/components/embeds/Passives'
import { treeWithLevel } from '@/logic/tree'
import { PassivesEmbed } from '@/types/embed'
import React from 'react'

function PassiveTreeView({
  embed,
  active,
  level,
  renderBackground = true,
  startFromActivePos,
  bandits
}: {
  embed: PassivesEmbed
  active?: number
  level?: number
  renderBackground?: boolean
  startFromActivePos?: boolean
  bandits?: string
}) {
  const tree = React.useMemo(
    () => treeWithLevel(embed, active, level, bandits),
    [embed, active, level, bandits]
  )
  return (
    <WithTreeData version={tree.version}>
      <PassiveTreeWithSearch
        embed={tree}
        hideBackground={!renderBackground}
        startFromActivePos={startFromActivePos}
      />
    </WithTreeData>
  )
}

export function PassiveTree({
  embed,
  ...props
}: {
  embed: PassivesEmbed
  active: number | undefined
  level?: number
  renderBackground?: boolean
  startFromActivePos?: boolean
  bandits?: string
}) {
  return (
    <WithTreeData version={embed.version}>
      <PassiveTreeView embed={embed} {...props} />
    </WithTreeData>
  )
}
